import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AppVersion, MENU_ITEMS } from "../../constants/GlobalConstants";

const Sidebar = ({ nav }) => {
  const toggleHandle = () => {
    nav.isSidebar === "wrapper"
      ? nav.setIsSidebar("wrapper toggled")
      : nav.setIsSidebar("wrapper");
  };
  const toggleMainMenu = () => {
    if (window.innerWidth > 1200) {
      nav.setIsSidebar("wrapper");
    }
  };

  return (
    <>
       <aside className="sidebar-wrapper">
      <div className="iconmenu">
        <button onClick={toggleHandle} style={{ marginRight: "-14px" }}>
          <div className="nav-toggle-box">
            <div className="nav-toggle-icon">
              <i className="bi bi-list" />
            </div>
          </div>
        </button>
        <ul className="nav nav-pills flex-column">
          {MENU_ITEMS.map((menu) => (
            <li
              key={menu.id}
              className="nav-item"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title={menu.tooltip}
            >
              <button
                onClick={toggleMainMenu}
                className="nav-link"
                data-bs-toggle="pill"
                data-bs-target={`#${menu.id}`}
                type="button"
              >
                <i className={menu.icon} />
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="textmenu">
        <div className="brand-logo">
          <img src="/assets/images/brand-logo-2.png" width={140} alt="Logo" />
          <div
            className="tooltip-item"
            style={{
              position: "absolute",
              bottom: "5px",
              right: "5px",
              backgroundColor: "#7C3AED",
              color: "#FFFFFF",
              fontSize: "0.5rem",
              padding: "3px 6px",
              borderRadius: "15px",
              boxShadow: "0 3px 4px rgba(0, 0, 0, 0.1)",
              fontWeight: "600",
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={`App Version: ${AppVersion}`}
          >
            V {AppVersion}
          </div>
        </div>
        <div className="tab-content">
          {MENU_ITEMS.map((menu) => (
            <div key={menu.id} className="tab-pane fade" id={menu.id}>
              <div className="list-group list-group-flush">
                <div className="list-group-item">
                  <div className="d-flex w-100 justify-content-between">
                    <h5 className="mb-0">{menu.title}</h5>
                  </div>
                  <small className="mb-0">{menu.tooltip} Management</small>
                </div>
                {menu.links.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="list-group-item"
                    onClick={() => nav.setIsSidebar("wrapper")}
                  >
                    <i className={link.icon}></i> {link.name}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </aside>
    </>
  );
};

export default Sidebar;
